import { StandardEvents } from '@shopify/events';

class LazyOafClearpay extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.generation = 0;
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.onProductSelect, { signal: this.abort.signal });
    this.section?.addEventListener('gift-card:variant-change', this.onGiftCardVariantChange, { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  onProductSelect = async (event) => {
    if (!event.target.closest('lazy-oaf-purchase:not([data-embedded])')) return;
    const generation = ++this.generation;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.generation) return;
      this.updatePlacement(detail?.resource);
    } catch {
      // Keep the last valid provider amount when a variant request fails.
    }
  };

  onGiftCardVariantChange = (event) => {
    this.updatePlacement(event.detail?.variant);
  };

  updatePlacement(variant) {
    const placement = this.querySelector('square-placement');
    if (!placement || !variant || typeof variant.price !== 'number') return;
    placement.dataset.amount = (variant.price / 100).toFixed(2);
    placement.dataset.itemSkus = variant.sku || String(variant.id);
  }
}

if (!customElements.get('lazy-oaf-clearpay')) customElements.define('lazy-oaf-clearpay', LazyOafClearpay);
